import type { MouseEvent } from 'react'
import type { LinkProps } from 'react-router-dom'
import { createContext, use } from 'react'
import { Link } from 'react-router-dom'

/**
 * Routes opened from Benny normally use the current app router. The desktop
 * companion provides a forwarding handler instead so links focus and navigate
 * the main Scrambl window rather than replacing the companion's own route.
 */
export const AssistantNavigationContext = createContext<
  ((path: string) => void) | null
>(null)

export function useAssistantNavigation() {
  return use(AssistantNavigationContext)
}

/** Internal app link that respects the companion-to-main navigation bridge. */
export function AssistantAppLink({ to, onClick, ...props }: LinkProps) {
  const forwardNavigate = useAssistantNavigation()

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event)
    if (event.defaultPrevented || !forwardNavigate || typeof to !== 'string') {
      return
    }

    event.preventDefault()
    forwardNavigate(to)
  }

  return <Link to={to} onClick={handleClick} {...props} />
}
